import { connect } from 'react-redux';
import { IState } from '../../store';
import { Dispatch } from 'redux';
import { TopPopup, ITopPopupDispatchProps } from './';
import { toggleTopPopup } from '../../store/hide_offer';

export const TopPopupContainer = connect(
  undefined,
  (dispatch: Dispatch<IState>): ITopPopupDispatchProps => ({
    toggleTopPopup: (isOpened: boolean) => () => dispatch(toggleTopPopup(isOpened)),
  }),
)(TopPopup);
